import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Observable } from "rxjs";
import { ToastrService } from 'ngx-toastr';

import { MessageTemplate } from '../../../api/models/message-template';
import { Customer } from '../../../api/models/customer';
import { EmailMessage } from '../../../api/models/email-message';
import { FormatMessage } from '../../../api/models/format-message';

import { CustomerService, DistributionListService, DistributionListItemService, MessageTemplateService,} from '../../../api/services';
import { DistributionTableService } from 'src/service/distribution.service';
import { MessageTemplateTableService } from 'src/service/message-template.service';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { DistributionList } from 'src/api/models/distribution-list';
import { DistributionListItem } from 'src/api/models/distribution-list-item';
import { DistributionListEvent } from 'src/api/models/distribution-list-event';
import { CustomerDistribution } from 'src/api/models/customer-distribution';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { DownloadCsvService } from 'src/service/download-csv.service';


@Component({
  selector: 'app-distribution',
  templateUrl: './distribution.component.html',
  styleUrls: ['./distribution.component.css']
})
export class DistributionComponent implements OnInit {
  @ViewChild("fileInput", { static: false }) fileInput: ElementRef;
  //@ViewChild("treeGrid", { read: IgxGridComponent, static: true }) public treeGrid: IgxGridComponent;
  //@ViewChild("itemGrid", { read: IgxGridComponent, static: false }) public itemGrid: IgxGridComponent;
  //@ViewChild("dialog", { read: IgxDialogComponent, static: true }) public dialog: IgxDialogComponent;
  //@ViewChild("distributionDialog", { read: IgxDialogComponent, static: true }) public distributionDialog: IgxDialogComponent;
  //@ViewChild("addressGrid", { static: true })  private addressGrid: IgxRowIslandComponent;
  //@ViewChild(IgxInputDirective, { read: IgxInputDirective, static: true }) public igxInput: IgxInputDirective;

  public customer : CustomerDistribution = {} as CustomerDistribution;
  public distribution : DistributionList = {} as DistributionList;

  public remoteTemplate: Observable<any[]>;
  public remoteData: Observable<any[]>;
  public remoteItemData: Observable<any[]>;

  //distributionListId: number;
  newListItem: DistributionListItem;
  editListItem: DistributionListItem;

  messageTemplateId: number;
  messageTemplate: MessageTemplate;
  subjectToSend: string;
  messageToSend: string;
  useTemplate: boolean;
  liveRender: string;
  liveSms: string;
  liveSubject: string;
  message: string = "{{message}}";
  public distributionList: DistributionList;
  public newDistributionList: DistributionList;

  constructor(
    public service: DistributionTableService,
    private distService: DistributionListService,
    private mtService: MessageTemplateTableService,
    private messageTemplateService: MessageTemplateService,
    private metaService: MessageTemplateService,
    private itemService: DistributionListItemService,
    public app: ApplicationConfigService,
    private customerService: CustomerService,
    public azureAuthService: AzureAuthService,
    private toasterService: ToastrService,
    private downloadCsvService: DownloadCsvService
  ) { 
    this.remoteTemplate = this.mtService.remoteData
    this.remoteData = this.service.remoteData;
    this.remoteItemData = this.service.remoteItemData;
    app.customerChanged$.subscribe(cid => {
      this.ngOnInit();
    });
  }

  ngOnInit(): void {    
    if (this.azureAuthService.isGlobalViewer()){
      if (this.app.customers == null){
        this.customerService.CustomerGetAllCustomers().subscribe(c => {           
          this.app.customers = c;//.filter(c=>c.active);          
        });
      }
    } 
    if (this.app.customerId == null) {
      this.app.customerId = this.azureAuthService.userProfile.customerId;
    }
    if (this.app.customerId){
      this.service.get(this.app.customerId);
    }
  } 

  changeCustomer(){
    if (this.azureAuthService.isGlobalViewer()){
      this.service.get(this.app.customerId);
    }
  }
  
  public removeRow(list) {
    // todo: move this into service 
    if (confirm("Are you sure you want to delete this Distribution List?")){
      this.service.remove(list.distributionListId);
    }
  }

  saveDistributionList(dist){
    dist.Customer = { customerId:this.app.customerId } as Customer;
    this.service.update(dist);
  }

  public editAddresses() {
    this.service.getItem(this.distributionList.distributionListId);    
  }

  public deleteAddress(address) {
    if (confirm("Are you sure you want to delete this Address?")){
      this.service.removeItem(address);
    }
  }

  public downloadAddresses(){
    var headers: any[];// = ['DistributionListItemId','ContactName','EmailAddress','MobileNumber','Enabled'];

    var data: any[] = [];
    this.service.distributionListItems.forEach(item => {
        data.push({
          'DistributionListItemId': item.distributionListItemId,
          'ContactName': item.contactName.replace(',',' '),
          'EmailAddress': item.emailAddress?.replace(',',';'),
          'MobileNumber': item.mobileNumber?.replace(',',';'),
          'AddressType': item.addressType,
          'Enabled': item.enabled});
    });

    if (data.length > 0) {
      let filename = `Contact List - ${this.distributionList.listName}.csv`
      this.downloadCsvService.downloadCSV(data, filename, Object.keys(data[0]), headers)
    }
  }

  public uploadingAddresses: boolean = false;
  public startUploadAddresses(){
    this.uploadingAddresses = true;
    this.importValidation = [];
    this.importValidated = false;
  }

  public cancelUploadAddresses(){
    this.uploadingAddresses = false;
    this.importValidation = [];
    this.importValidated = false;
    this.importEvents = [];
    this.fileInput.nativeElement.value = "";
    this.service.getItem(this.distributionList.distributionListId);
  }

  public importValidation = [];
  public importValidated : boolean = false;
  public importedContacts : DistributionListItem[];

  public importContacts(files){
    //if(!window.FileReader) return; // Browser is not compatible
    var reader = new FileReader();
    this.importValidated = true;
    this.importValidation = [];
    this.importedContacts = [];
    var upload = (d) => {
      console.log(d);
      var arr = d.split("\r\n");
      for (var i = 0; i < arr.length; i++){
        if (i == 0){
          // validate the header
        }
        else {
          var row = arr[i].split(',');
          if (row.length > 7){
              this.importValidation.push(`Invalid File Format - Row ${i} contains to many columns: ${row.length}`);
              this.importValidated = false;
          }
          if (row.length < 7 && row.length != 1){
            this.importValidation.push(`Invalid File Format - Row ${i} does not contain enough columns: ${row.length}`);
            this.importValidated = false;
          }
          if (row.length == 7){
            try{
              this.importedContacts.push({
                distributionListItemId : +row[1],
                contactName : row[2],
                emailAddress : row[3],
                mobileNumber : row[4],
                addressType : +row[5],
                enabled : row[6] == 'true'
              } as DistributionListItem);
              this.importValidation.push(`Row ${i} Validated`);
            }
            catch {
              this.importValidation.push(`Invalid File Format - Row ${i} contains invalid data types`);
              this.importValidated = false;
            }
          }
        }
      }
      
      //this.fileInput.nativeElement.value = "";
    };
    reader.onload = function(evt:any) {
      if(evt.target.readyState != 2) return;
      if(evt.target.error) {
          alert('Error while reading file');
          return;
      }

      const filecontent = evt.target.result;
      
      upload(filecontent.toString());
    };

    reader.readAsText(files[0]);
  }

  public importEvents: string[];

  public executeImport(){
    this.importEvents = [];
    this.importValidation = [];
    var success = 0;
    var failed = 0;
    var itemsToDelete: DistributionListItem[] = [];
    //clone all items - then remove ones that have been updated
    for (let contact of this.service.distributionListItems){
      itemsToDelete.push(contact);
    }
    for (let contact of this.importedContacts){
      var match: DistributionListItem = null;
      if (contact.distributionListItemId && contact.distributionListItemId > 0){
        match = this.service.distributionListItems.find(c => c.distributionListItemId == contact.distributionListItemId);
      }
      if (match != null){
        const index = itemsToDelete.indexOf(match);
        if (index > -1) { // only splice array when item is found
          itemsToDelete.splice(index, 1); // 2nd parameter means remove one item only
        }
        match.addressType = contact.addressType;
        match.contactName = contact.contactName;
        match.emailAddress = contact.emailAddress;
        match.mobileNumber = contact.mobileNumber;
        match.enabled = contact.enabled;
        this.itemService.DistributionListItemCreateOrUpdate(match).subscribe(r => {
          success++;
          //this.toasterService.success("Contact Updated");
          this.importEvents.push("Contact Updated: " + match.contactName);
          if (success == this.importContacts.length){
            this.toasterService.success("Upload Contacts Successful");
            //this.cancelUploadAddresses();
          }
        }, e => {
          failed++;
          this.importEvents.push("Error Updating Contact: " + match.contactName);
          this.toasterService.error("Error Updating Contact");
        });
      } else {
        //this.service.addItem(this.distributionList.distributionListId, contact);
        contact.distributionListId = this.distributionList.distributionListId;
        contact.distributionListItemId = 0;
        this.itemService.DistributionListItemCreateOrUpdate(contact).subscribe(r => {
          success++;
          //this.toasterService.success("Contact Added");
          this.importEvents.push("Contact Added: " + contact.contactName);
          if (success == this.importContacts.length){
            this.toasterService.success("Upload Contacts Successful");
            //this.cancelUploadAddresses();
          }
        }, e => {
          failed++;
          this.importEvents.push("Error Adding Contact: " + contact.contactName);
          this.toasterService.error("Error Adding Contact");
        });
      }
    }
    for (let contact of itemsToDelete){
      this.itemService.DistributionListItemDelete(contact.distributionListItemId).subscribe(r => {
        this.toasterService.success("Contact Removed");
        this.importEvents.push("Contact Removed: " + contact.contactName);
      }, e => {
        failed++;
        this.importEvents.push("Error Removing Contact: " + contact.contactName);
        this.toasterService.error("Error Removing Contact");
      });
    }
  }

  public validateEmail(email){
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  public addAddress() {
    this.newListItem = {enabled:true} as DistributionListItem;
  }

  public editAddress(address){
    this.editListItem = address;
  }

  public saveNewAddress(){
    if (this.newListItem.emailAddress && this.newListItem.mobileNumber && this.newListItem.contactName){
      this.service.addItem(this.distributionList.distributionListId, this.newListItem);
      this.newListItem = null;
    }
  }

  public saveAddress(){
    if (this.editListItem.emailAddress && this.editListItem.mobileNumber && this.editListItem.contactName){
      this.service.updateItem(this.editListItem);
      this.editListItem = null;
    }
  }

  public cancelAddress(address){
    this.editListItem = null;
  } 

  public addList(){
    this.newDistributionList = {} as DistributionList;
  }

  public addListSave(){
    this.service.add(this.app.customerId, this.newDistributionList);
  }

  public updateListSave(){
    this.service.update(this.distributionList)
  }

  public addNewItem(){
    this.service.addItem(this.distributionList.distributionListId, {enabled:true} as DistributionListItem);
  }

  public isDeleted(rowContext: any) {
    return rowContext && rowContext.deleted;
  }

  /*public prepareMessage(cell) {
    this.distributionListId = cell.rowData.distributionListId;
  }*/

  public sendMessage(){
    this.distService.DistributionListSend({
      message:this.messageToSend,
      subject:this.subjectToSend,
      applyTemplate:this.useTemplate,
      customerId: this.app.customerId,
      distributionListId: this.distributionList.distributionListId,
      messageTemplateId: this.messageTemplateId,
    } as EmailMessage).subscribe(a => {
        this.toasterService.success("Message Sent", "");
    }, err => {
        this.toasterService.error("Failed to send message", "");
    });
  }

  /*public editTemplate(cell){
    this.distributionListId = cell.rowData.distributionListId;
    this.distributionList = cell.rowData;
  }*/

  public saveMessageTemplate(){
    this.distService.DistributionListCreateOrUpdate(this.distributionList)
      .subscribe(a => {
        this.toasterService.success("Message Template Saved", "");
    }, err => {
        this.toasterService.error("Failed to update Message Template", "");
    });
  }

  messageChangedCount: number = 0;

  public messageChanged($event){
    if (this.useTemplate){
      this.messageChangedCount++;
      var innerCount = this.messageChangedCount;
      if (this.messageToSend == null || this.messageToSend.trim() == ""){
        // no message, so use the default for the template
        this.toasterService.success("Default Message Example Automatically Applied", "Input Data");
        this.messageToSend = this.messageTemplate.sampleMessage;
        this.useTemplate = true;
      }
      setTimeout(() => {
        if (this.messageChangedCount == innerCount){
          this.metaService.MessageTemplateFormatMessage({
            emailMessage:{
              message:this.messageToSend,
              subject:this.subjectToSend,
              applyTemplate:this.useTemplate,
              messageTemplateId:this.messageTemplateId,
              value: JSON.stringify({ point: { value: this.messageTemplate.sampleMessage }, metaData:{source:"INDICIUM Cloud - Send Message"}}),
              distributionListId: this.distributionList.distributionListId
            } as EmailMessage,
            messageTemplate: this.messageTemplate
          } as FormatMessage).subscribe(r => {
            this.liveRender = r.message;
            this.liveSms = r.sms;
            this.liveSubject = r.subject;
          });
        }
      }, 1000);
    } else {
        this.liveRender = this.messageToSend;
    }
  }

  history: DistributionListEvent[];
  event: DistributionListEvent;

  public getHistory() {    
    this.distService.DistributionListGetRecentEvents(this.distributionList.distributionListId).subscribe(r => {
      this.history = r;
    });
  }

  public selectEvent(e: DistributionListEvent){
    this.event = e;
  }

  public templateChanged(){
    if (this.messageTemplateId != null){
      this.messageTemplateService.MessageTemplateGetMessageTemplate(this.messageTemplateId).subscribe(mt => {
        this.messageTemplate = mt;
        this.messageChanged(null);
      });
    }
  }

}


